// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","submit":"styles_submit__K5IbT","form":"styles_form__Pdn0m"};